import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

import useApiHelper from "../hooks/useApiHelper";
import { DefaultResponseWithData } from "../models/system";
import { BulkListingStatsResponse } from "../models/bulkListings/BulkListing";

export default function useBulkListingStats() {
  const { get, post, put, del } = useApiHelper();
  const queryClient = useQueryClient();

  const stats = useQuery({
    queryKey: ["bulkListing", "stats"],
    queryFn: () => get<DefaultResponseWithData<BulkListingStatsResponse>>("/bulklisting/stats"),
    staleTime: 1000 * 60 * 10, //10 minutes
  });

  return {
    stats
  };
}
